import { observer } from "mobx-react";
import useStore from "../../../store";
import { useEffect, useState } from "react";
import PageHeader from '../../../component/PageHeader';
import { Form, Input, Select, DatePicker, Space, Tooltip, Spin } from 'antd';
import { SearchOutlined, InfoCircleOutlined, SwapOutlined } from '@ant-design/icons';
import ListComponent from "./Component/ListComponent";
import { PlatformBookingBreadcrumb } from "../../../config/BreadcrumbConfig";
import dayjs from "dayjs";
import { Button } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const { Option } = Select;

const PlatformBooking = observer(() => {
	const { PLATFORMBOOKING } = useStore();
	const [form] = Form.useForm();

	const onSearch = (text) => {
		PLATFORMBOOKING.searchValue = text;
		PLATFORMBOOKING.setupGrid(PLATFORMBOOKING.agGrid);
	};

	const onStatusChange = (value) => {
		PLATFORMBOOKING.bookingStatus = value;
		PLATFORMBOOKING.setupGrid(PLATFORMBOOKING.agGrid);
	};

	const onDateChange = (dates) => {
		if (dates) {
			PLATFORMBOOKING.checkIn = dates[0].startOf('day').toISOString();
			PLATFORMBOOKING.checkOut = dates[1].startOf('day').toISOString();
		} else {
			PLATFORMBOOKING.checkIn = null;
			PLATFORMBOOKING.checkOut = null;
		}
		PLATFORMBOOKING.setupGrid(PLATFORMBOOKING.agGrid);
	};

	const [propertyLookupLoading, setPropertyLookupLoading] = useState(true);

	useEffect(() => {
		return () => {
			PLATFORMBOOKING.searchValue = '';
			PLATFORMBOOKING.bookingStatus = 0;
			PLATFORMBOOKING.checkIn = dayjs(new Date()).toDate(),
			PLATFORMBOOKING.checkOut = dayjs(new Date()).add(15, 'days').toDate(),
			PLATFORMBOOKING.propertyId = '';
			PLATFORMBOOKING.propertyList = [];
		};
	}, []);

	const filterContent = (
		<div className="platform-booking-filters">
			<div className="filter-item">
				<label>
					Search
					<Tooltip title="Search by Property,Booking No, Name or Mobile No">
						<InfoCircleOutlined style={{ fontSize: '12px', color: '#8c8c8c' }} />
					</Tooltip>
				</label>
				<Input
					placeholder="Search"
					prefix={<SearchOutlined style={{ color: '#bfbfbf' }} />}
					onChange={(e) => onSearch(e.target.value)}
					style={{ width: '200px' }}
				/>
			</div>

			<div className="filter-item">
				<label>Property</label>
				<Select
					showSearch
					placeholder="Select Property"
					value={PLATFORMBOOKING.propertyId || undefined}
					style={{ width: '200px' }}
					onFocus={() =>
						propertyLookupLoading &&
						PLATFORMBOOKING.getPropertyLookup().then(() =>
							setPropertyLookupLoading(false)
						)
					}
					onChange={(value) => {
						PLATFORMBOOKING.propertyId = value;
						PLATFORMBOOKING.setupGrid(PLATFORMBOOKING.agGrid);
					}}
					filterOption={(input, option) =>
						(option?.label ?? '').toLowerCase().includes(input.toLowerCase())
					}
					options={PLATFORMBOOKING.propertyList?.map(p => ({ label: p.propertyName, value: p.ePropertyId })) || []}
					notFoundContent={propertyLookupLoading ? <Spin size="small" /> : null}
				/>
			</div>

			<div className="filter-item">
				<label>Check In/Out</label>
				<DatePicker.RangePicker
					format="DD-MM-YYYY"
					defaultValue={[dayjs(PLATFORMBOOKING.checkIn), dayjs(PLATFORMBOOKING.checkOut)]}
					onChange={onDateChange}
					separator={<SwapOutlined style={{ color: '#bfbfbf' }} />}
				/>
			</div>
			<div>
<a
						key="export"
						id="export-download-link"
						style={{ textDecoration: 'none' }}
						target="_blank"
						download={'Enquiry-record.xlsx'}
					>
						<Button
							type="primary"
							icon={<FontAwesomeIcon icon={faDownload} />}
							onClick={() => PLATFORMBOOKING.exportPlatformBooking()}
							title={'Download Excel File'}
						>
							Download
						</Button>
					</a>,
			</div>
		</div>
	);

	return (
		<div className="mainPageWrap">
			<PageHeader
				className="mainPageHeader"
				title={PlatformBookingBreadcrumb.title}
			/>
			<div style={{ marginBottom: '20px' }}>
				{filterContent}
			</div>
			<ListComponent />
		</div>
	);
});

export default PlatformBooking;
